import * as React from "react";
import {GroupProperties} from "InternalShared/PageBuilder/Controls/Properties/styles/GroupProperties";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {DimensionStyleSet} from "InternalShared/PageBuilder/Controls/Properties/StyleSets/DimensionStyleSet";
import {AllowedResizeDirection} from "InternalShared/Dto";
import {ImageProperty} from "InternalShared/PageBuilder/Controls/Properties/ImageProperty";
import {SimpleTextProperty} from "InternalShared/PageBuilder/Controls/Properties/SimpleTextProperty";
import {PropertyBase} from "InternalShared/PageBuilder/Controls/Properties/PropertyBase";
import {CheckBoxProperty} from "InternalShared/PageBuilder/Controls/Properties/CheckBoxProperty";
import {
    InvoiceDetailColumnFormatEnum,
    InvoiceDetailColumnTypeEnum,
    InvoiceDetailControlOptions,
    RowSeparatorEnum
} from "./InvoiceDetailControl.Options";
import {HTMLTableCreator} from "shared/utilities/HTMLTableCreator/HTMLTableCreator";
import {CurrencyUtils} from "PageBuilder/utils/CurrencyUtils";
import {EventManager} from "shared/utilities/Events/EventManager";
import {UpdateFieldSettingsPanel} from "InternalShared/Events/UpdateFieldSettingsPanel";
import {DropDownProperty} from "InternalShared/PageBuilder/Controls/Properties/DropDownProperty";
import {ColorProperty} from "InternalShared/PageBuilder/Controls/Properties/ColorProperty";
import {UpdateStyleSettingsPanel} from "InternalShared/Events/UpdateStyleSettingsPanel";


declare let rednaoPDFInvoiceParams:any;
export class InvoiceDetailControl extends PDFControlBase{


    public AllowedResizeDirection: AllowedResizeDirection = "horizontal";
    GetStyles(): GroupProperties[] {
        let properties=[];
        properties.push(DimensionStyleSet.GetStyles(this));
        properties.push(new GroupProperties('Header Styles').AddProperties([
            new ColorProperty(this,'background-color',this.StyleManager.CreateStyleClassManager('.productDetail th')).SetLabel('Background Color')
                .AddStyles({width:'50%',display:'inline-block'}),
            new ColorProperty(this,'color',this.StyleManager.CreateStyleClassManager('.productDetail th')).SetLabel('Color')
                .AddStyles({width:'50%',display:'inline-block'})
        ]));


        switch (this.Options.RowSeparator) {
            case RowSeparatorEnum.Stripped:
                properties.push(
                    new GroupProperties('Separator Styles').AddProperties([
                        new ColorProperty(this,'OddBackground').SetLabel('Odd Background')
                            .AddStyles({width:'50%',display:'inline-block'}).OnChange(e=>this.SetInitialStyles()),
                        new ColorProperty(this,'OddColor',this.Options).SetLabel('Odd Color')
                            .AddStyles({width:'50%',display:'inline-block'}).OnChange(e=>this.SetInitialStyles()),
                        new ColorProperty(this,'EvenBackground').SetLabel('Even Background')
                            .AddStyles({width:'50%',display:'inline-block'}).OnChange(e=>this.SetInitialStyles()),
                        new ColorProperty(this,'EvenColor',this.Options).SetLabel('Even Color')
                            .AddStyles({width:'50%',display:'inline-block'}).OnChange(e=>this.SetInitialStyles())
                    ])
                );
                break;

            case RowSeparatorEnum.Line:
            case RowSeparatorEnum.LastRow:
                properties.push(
                    new GroupProperties('Separator Styles').AddProperties([
                    new ColorProperty(this,'BorderColor').SetLabel('Border Color')
                       .OnChange(e=>this.SetInitialStyles()),
                    new ColorProperty(this,'background-color',this.StyleManager.CreateStyleClassManager('.productDetail tbody')).SetLabel('Background Color')
                        .AddStyles({width:'50%',display:'inline-block'}),
                    new ColorProperty(this,'color',this.StyleManager.CreateStyleClassManager('.productDetail tbody')).SetLabel('Color')
                        .AddStyles({width:'50%',display:'inline-block'})

                    ]));


                break;

            case RowSeparatorEnum.None:
                properties.push(
                    new GroupProperties('Separator Styles').AddProperties([
                        new ColorProperty(this,'background-color',this.StyleManager.CreateStyleClassManager('.productDetail tbody')).SetLabel('Background Color')
                            .AddStyles({width:'50%',display:'inline-block'}),
                        new ColorProperty(this,'color',this.StyleManager.CreateStyleClassManager('.productDetail tbody')).SetLabel('Color')
                            .AddStyles({width:'50%',display:'inline-block'})
                    ]));

        }


        properties.push(new GroupProperties('Total Styles').AddProperties([
            new ColorProperty(this,'background-color',this.StyleManager.CreateStyleClassManager('.footerDetail .total')).SetLabel('Background Color')
                .AddStyles({width:'50%',display:'inline-block'}),
            new ColorProperty(this,'color',this.StyleManager.CreateStyleClassManager('.footerDetail .total')).SetLabel('Color')
                .AddStyles({width:'50%',display:'inline-block'})
        ]));

        return properties;
    }
    public Options:InvoiceDetailControlOptions;
    private properties:GroupProperties[];



    SetInitialStyles() {
        super.SetInitialStyles();
        this.StyleManager.ClearFieldStyles();
        this.StyleManager.AddStyleSet('.productDetail, .footerDetail',{'border-collapse':'collapse'});
        this.StyleManager.AddStyleSet('.productDetail, .footerDetail',{'border-spacing':'0'});
        this.StyleManager.AddStyleSet('.productDetail',{'width':'100%'});
        this.StyleManager.AddStyleSet('.productDetail .price',{'text-align':'right'});
        this.StyleManager.AddStyleSet('.productDetail .name',{'text-align':'left'});
        this.StyleManager.AddStyleSet('.footerDetail',{'width':'300px','margin-left':'auto'});
        this.StyleManager.AddStyleSet('.footerDetail th',{'text-align':'left'});
        this.StyleManager.AddStyleSet('.footerDetail td',{'text-align':'right'});
        this.StyleManager.AddStyleSet('.productTable td',{'padding':'5px'});
        this.StyleManager.AddStyleSet('.productTable td, .productTable th',{'padding':'9px 5px'});

        this.StyleManager.AddStyleSet('.productDetail th',{'background-color':"#336ed0"});
        this.StyleManager.AddStyleSet('.productDetail th',{'color':"white"});
        this.StyleManager.AddStyleSet('.footerDetail .total',{'background-color':"#336ed0"});
        this.StyleManager.AddStyleSet('.footerDetail .total',{'color':"white"});

        if(this.Options.RowSeparator==RowSeparatorEnum.Line.toString())
        {
            this.StyleManager.AddStyleSet('.productDetail td',{'border-bottom':'1px solid #dfdfdf'});
        }

        if(this.Options.RowSeparator==RowSeparatorEnum.Stripped)
        {
            this.StyleManager.AddStyleSet('.productDetail > tbody tr:nth-of-type(odd)',{
                'background-color': this.Options.OddBackground,
                'color':this.Options.OddColor
            });

            this.StyleManager.AddStyleSet('.productDetail tr:nth-of-type(even)',{
                'background-color': this.Options.EvenBackground,
                'color':this.Options.EvenColor
            });
        }

        if(this.Options.RowSeparator==RowSeparatorEnum.Line)
        {
            this.StyleManager.AddStyleSet('.productDetail td',{'border-bottom':'1px solid '+this.Options.BorderColor});
        }

        if(this.Options.RowSeparator==RowSeparatorEnum.LastRow)
        {
            this.StyleManager.AddStyleSet('.productDetail tr:last-child td',{'border-bottom':'1px solid '+this.Options.BorderColor});
        }

    }

    public NeedTranslations(): boolean {
        return true;
    }

    public GetTranslatedText(): any {
        return {text:''};
    }

    protected GetFakeData(){
        return [
            {name:'My awesome product 1',price:10},
            {name:'My awesome product 2',price:20},
            {name:'My awesome product 3',price:30}
        ]
    }

    protected InternalGenerateHtml($container: JQuery) {

        let creator=new HTMLTableCreator('productDetail productTable');
        $container.append(creator.Table);
        creator.CreateTHead();
        creator.CreateRow();
        for(let column of this.Options.Columns)
        {
            creator.CreateTextColumn(column.Label,column.Type,'th');
        }

        creator.CreateTBody();
        for(let row of this.GetFakeData())
        {
            creator.CreateRow();
            for(let column of this.Options.Columns)
            {
                let value=row[column.Type];
                if(value==null)
                    value=0;
                if(column.Format==InvoiceDetailColumnFormatEnum.number)
                    value=CurrencyUtils.GetInstance().FormatValue(value);
                creator.CreateTextColumn(value,column.Type);
            }
        }

        if(this.Options.ShowGrandTotal)
        {
            let footCreator=new HTMLTableCreator('footerDetail productTable');
            $container.append(footCreator.Table);
            footCreator.CreateTBody();
            footCreator.CreateRow();
            footCreator.CreateTextColumn(this.Options.GrandTotalLabel,'total','th');
            footCreator.CreateTextColumn(CurrencyUtils.GetInstance().FormatValue(60),'total');

        }




    }

    public GetProperties(): GroupProperties[] {
        let properties=[];

        properties.push(new DropDownProperty(this,'RowSeparator')
            .AddOption('None','none')
            .AddOption('Line','line')
            .AddOption('Stripped','stripped')
            .AddOption('Last','last')
            .OnChange(e=>{
                EventManager.Publish(new UpdateFieldSettingsPanel());
                EventManager.Publish(new UpdateStyleSettingsPanel());
                this.SetInitialStyles();
            })
        );

        properties.push(new CheckBoxProperty(this,"ShowGrandTotal").SetLabel('Show Grand Total').OnChange(e=>{
            EventManager.Publish(new UpdateFieldSettingsPanel());
        }));
        if(this.Options.ShowGrandTotal)
            properties.push(new SimpleTextProperty(this,"GrandTotalLabel").SetLabel('Grand total label'));
        return [new GroupProperties('General').AddProperties(properties)];
    }


    public AfterRefresh() {

    }

    GetInitialOptions(): Promise<any> {
        return new Promise(resolve => {
            resolve(new InvoiceDetailControlOptions().Merge(
                {
                    Styles:{Left:'2%',Width:'96%'},
                    Columns:[
                        {Label:'Product',Type:InvoiceDetailColumnTypeEnum.ProductName,Format:InvoiceDetailColumnFormatEnum.string},
                        {Label:'Price',Type:InvoiceDetailColumnTypeEnum.Price,Format:InvoiceDetailColumnFormatEnum.number},
                    ]

                })
            );
        });
    }

    private GenerateTable(container:HTMLElement) {


    }

    protected InternalGetLabel() {
        return 'Image';
    }

    GetValueEditor(): PropertyBase {
        return new ImageProperty(this,'URL').SetLabel('').SetWidth(100);
    }
}
